import { RouteType, StripeStatus } from "../../routes/config"; 
import "../../fontawesome";
import { Link } from "react-router-dom";
import { useState } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown } from "@fortawesome/free-solid-svg-icons"; 

type Props = {
    item: RouteType;
    toggleModal: () => void;
    path: string;
    setPath: (e: string) => void;
    userStripeStatus: StripeStatus; 
};

// Helper function to determine access based on tier
const checkAccess = (userTier: StripeStatus, requiredTier?: StripeStatus): boolean => {
    if (!requiredTier || requiredTier === 'free') {
        return true; // Accessible to all if no tier specified or if 'free'
    }
    // At this point, requiredTier is 'light' or 'premium'

    if (userTier === 'premium') {
        return true; // Premium can access 'light' and 'premium' requiredTiers
    }
    // At this point, userTier is 'light' or 'free', and requiredTier is 'light' or 'premium'

    if (userTier === 'light') {
        // User is 'light', requiredTier is known to be 'light' or 'premium'.
        return requiredTier === 'light'; // Access if requiredTier is 'light', deny if 'premium'.
    }
    // At this point, userTier is 'free', and requiredTier is 'light' or 'premium'.
    return false; // Free users cannot access 'light' or 'premium' requiredTiers.
};

const SidebarItem = ({ item, userStripeStatus, path, setPath, toggleModal }: Props) => { 
    const hasRequiredTier = item.sidebarProps?.requiredTier;
    const canAccess = checkAccess(userStripeStatus, hasRequiredTier);

    const showUpgradeIcon = 
        hasRequiredTier && 
        hasRequiredTier !== 'free' && 
        !canAccess;

    return item.sidebarProps ? (
        <Link
            className={clsx(
                !canAccess && "opacity-50 cursor-not-allowed", 
                "grid grid-flow-col auto-cols-max gap-2 p-3 cursor-pointer group relative hover:text-primary-pink",
                path === item.path && "border-l-2 border-primary-pink"
            )}
            to={!canAccess && hasRequiredTier && hasRequiredTier !== 'free' ? "/premium" : (item.path || "#")}
            onClick={(e) => {
                if (!canAccess && hasRequiredTier && hasRequiredTier !== 'free') {
                    e.preventDefault(); 
                    // Redirecting via 'to' prop, or could use navigate('/premium') or toggleModal for upgrade
                    // If using toggleModal for an upgrade prompt:
                    // toggleModal(); 
                    // Or navigate to a dedicated upgrade page if toggleModal isn't for that purpose
                    // For now, Link's 'to' prop handles redirection.
                }
                if (item.path && canAccess) setPath(item.path);
            }}
        >
            {item.sidebarProps.icon}
            <span className={clsx("truncate group-hover:text-primary-pink", path === item.path && "text-primary-pink font-semibold")}>
                {item.sidebarProps.displayText}
            </span>
            {showUpgradeIcon && (
                 <FontAwesomeIcon icon={faCrown} className="absolute top-1 right-1 text-yellow-500 text-xs" />
            )}
        </Link>
    ) : null;
};

export default SidebarItem;
